import { useEffect } from "react";
import { StoreButtons, PLAY_STORE_URL as ANDROID_REDIRECT, APP_STORE_URL as IOS_REDIRECT } from "../components/StoreButtons";
import { useSiteLang } from "../lib/siteLang";
import { applySeo } from "../lib/seo";

// Smart deep-link page: sends the visitor to the right store for the phone. A computer shows the two buttons.
// This is the target of the QR codes (/download).

export default function Download() {
  const { lang } = useSiteLang();

  useEffect(() => applySeo({ path: "/download" }), []);

  useEffect(() => {
    document.title = lang === "it" ? "Scarica GozzoGuide" : "Download GozzoGuide";

    const ua = navigator.userAgent || navigator.vendor || window.opera || "";
    if (/android/i.test(ua)) {
      window.location.replace(ANDROID_REDIRECT);
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      window.location.replace(IOS_REDIRECT);
    }
    // On a computer or another device the page stays and shows the two buttons
  }, [lang]);

  return (
    <div className="min-h-screen bg-[#09101F] text-white flex flex-col items-center justify-center text-center px-6" data-testid="download-page">
      <img src="/images/logo-192.png" alt="GozzoGuide" className="w-24 h-24 rounded-3xl mb-5 object-cover" data-testid="download-logo" />
      <h1 className="text-2xl mb-2" data-testid="download-title">GozzoGuide</h1>
      <p className="font-tagline text-xl text-white/80 mb-8" data-testid="download-redirect-msg">
        {lang === "it" ? "La tua guida personale in tasca" : "Your personal guide in your pocket"}
      </p>
      <StoreButtons className="justify-center" />
    </div>
  );
}
